import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../state/AppContext";

let CACHED = null;
let PENDING = null;

// Fetches non-secret public config (guide URLs, tour URL, email-configured flag)
// once per page load. Safe to call from any component.
export function usePublicConfig() {
  const [cfg, setCfg] = useState(CACHED || {});
  useEffect(() => {
    if (CACHED) return;
    if (!PENDING) {
      PENDING = axios.get(`${API}/config/public`).then((r) => {
        CACHED = r.data || {};
        return CACHED;
      }).catch(() => {
        CACHED = {};
        return CACHED;
      });
    }
    let live = true;
    PENDING.then((d) => { if (live) setCfg(d); });
    return () => { live = false; };
  }, []);
  return cfg;
}
